import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import trackEvent from 'misc/trackEvent';
import { VisuallyHidden } from '@seismic/mantle';
import FlipcardSide from './FlipcardSide';
import { FlipcardTypes } from './types';

const Flipcard = ({
  alt_content_image_url: altContentImageUrl,
  back,
  content_image_url: contentImageUrl,
  id: flipcardId,
  front,
  instruction,
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isOver, setIsOver] = useState(false);
  const [flippedHeight, setFlippedHeight] = useState('auto');
  const [assistiveHelpText, setAssistiveHelpText] = useState(
    t('lessons.editor.flipcard.front_card_assistive'),
  );
  const frontCardRef = useRef(null);
  const backCardRef = useRef(null);

  const flipOver = currentSide => {
    if (currentSide === 'front') {
      setIsFlipped(true);
      setAssistiveHelpText(t('lessons.editor.flipcard.back_card_assistive'));
      backCardRef.current.focus();
    } else {
      setIsFlipped(false);
      setAssistiveHelpText(t('lessons.editor.flipcard.front_card_assistive'));
      frontCardRef.current.focus();
    }
  };

  useEffect(() => {
    const throttleSetHeight = height => {
      setTimeout(() => {
        setFlippedHeight(height);
      }, 300);
    };

    if (isFlipped) {
      throttleSetHeight(backCardRef.current.parentElement.clientHeight);
      trackEvent('flipcard_flipped', { flipcard_id: flipcardId }, false);
    } else {
      throttleSetHeight('auto');
    }
  }, [flipcardId, isFlipped]);

  return (
    <div
      className={cn({
        'is-flipped': isFlipped,
        'is-over': !isFlipped && isOver,
      })}
      style={{ height: flippedHeight }}
      aria-label={t('lessons.editor.flipcard.flip_card')}
    >
      <div className="Flipcard-container">
        <VisuallyHidden aria-live="assertive">
          {assistiveHelpText}
        </VisuallyHidden>
        <FlipcardSide
          ref={frontCardRef}
          isFlipped={isFlipped}
          htmlContent={front}
          imageUrl={contentImageUrl}
          instruction={instruction}
          imageAriaLabel={t('lessons.editor.flipcard.content_image.label')}
          side="front"
          flipOver={flipOver}
          setIsOver={setIsOver}
        />
        <FlipcardSide
          ref={backCardRef}
          isFlipped={!isFlipped}
          htmlContent={back}
          imageUrl={altContentImageUrl}
          imageAriaLabel={t('lessons.editor.flipcard.alt_content_image.label')}
          side="back"
          flipOver={flipOver}
          setIsOver={setIsOver}
        />
      </div>
    </div>
  );
};

Flipcard.propTypes = FlipcardTypes;

export default Flipcard;
